


















































































































































































































import { defineComponent } from '@vue/composition-api';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import FooterColumnsTitle from './FooterColumnsTitle.vue';
import { getConfig } from '@superbet-group/web.lib.config';
import { getWikiPath } from '@modules/wiki/navigateToWiki';

import {
    useTheme,
    SdsLink,
} from '@superbet-group/web.lib.ui-components';

export default defineComponent({
    name: 'LegalSection',
    setup() {
        const { theme } = useTheme();

        return {
            footerLocalConfig: shellLocalConfig.footer,
            gamblingTherapyLink: `https://www.gamblingtherapy.org/${getConfig().appLocale.locale.toLowerCase()}/information/`,
            theme,
            getWikiPath,
        };
    },
    components: {
        FooterColumnsTitle,
        SdsLink,
    },
});
